import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { IoSchool as SchoolIcon } from 'react-icons/io5';
import { FaStar as StarIcon } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Education.css';
import { timelineData } from '../data/portfolioData';

const Education: React.FC = () => {
  const educationItems = timelineData.filter(item => item.timelineType === 'education');

  return (
    <>
      <div className="education-header">
        <h2 className="education-title">Education</h2>
      </div>
      <VerticalTimeline>
        {educationItems.map((item, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--education"
            contentStyle={{
              background: '#2a1a1a',
              color: '#fff',
              borderTop: '3px solid #e50914',
              borderRadius: '8px',
              boxShadow: '0 4px 14px rgba(229, 9, 20, 0.25)',
            }}
            contentArrowStyle={{ borderRight: '7px solid #2a1a1a' }}
            date={item.dateRange}
            iconStyle={{ background: '#e50914', color: '#fff' }}
            icon={<SchoolIcon />}
          >
            <div style={{ color: '#fff' }}>
              <h3 className="vertical-timeline-element-title" style={{ fontSize: '1.2rem', fontWeight: 700 }}>{item.name}</h3>
              <h4 className="vertical-timeline-element-subtitle" style={{ color: '#e50914', marginTop: '4px' }}>{item.title}</h4>
              <p style={{ color: '#ccc', fontSize: '0.9rem', lineHeight: 1.6 }}>{item.summaryPoints}</p>
            </div>
          </VerticalTimelineElement>
        ))}
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
      <div className="education-cta">
        <p className="education-cta-text">Want to see the full picture?</p>
        <Link to="/work-experience" className="education-cta-btn">View Experience & Education Timeline</Link>
      </div>
    </>
  );
};

export default Education;
